// User facing project names
// NOTE: Duplicates must have a space after them, or there will be bugs
const projectList = {
	aatf: "Atmospherics",
	afghanistandemo: "Afghanistan",
	afghanistanDFAT:"Afghanistan - DFAT",
	arlis:"Fido",
	africom: "Baghdad",
	asksage: "Ask Sage",
	au2024_trial: "Thunder Trial",
	china: "Baseline Platform",
	delphi: "Delphi",
	AU_DIO_2025: "AU DIO 2025",
	AU_THUNDER_2025: "AU THUNDER 2025",
	CA_ORCA_2025: "CA ORCA 2025",
	GLOVER: "Glover",
	INDOPACOM_JIATFW: "INDOPACOM JIATFW",
	VIOLIN: "Violin",
	DIESEL: "Diesel",
	RELISH: "Relish",
	islamabad: "Islamabad",
	kabul: "Kabul",
	koala: "Koala",	
	oseRussia: "Russia", // CHANGE TO USE "russia" ID ???
	scorpion: "Scorpion",
	narrativeMapDemo: "Narrative Map Demo",
	iraq: "Iraq", // REMOVE ???
	brasilia: "DOS-Brasilia", // REMOVE ???
	venezuela: "Venezuela", // REMOVE ???
};

export default projectList;
